/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector } from "react-redux";
import "./introduction-card.m.css";
import get from "lodash/get";

export const PageIntroduction = Component => props => {
  const { pageType = "", config = {} } = useSelector(state => get(state, ["qt"], {}));

  const supportedPages = {
    "tag-page": "tag",
    "author-page": "author",
    "authors-page": "authors",
    "magazine-landing-page": "magazine-landing",
    "magazine-archive-page": "archive",
    "": ""
  };
  const magazinePage = pageType === "magazine-landing-page" || pageType === "magazine-archive-page";
  const updatedPath = !magazinePage ? [supportedPages[pageType]] : ["magazine", supportedPages[pageType], "rows", "0"];

  const theme = get(config, ["pagebuilder-config", ...updatedPath, "pageSetting", "bgColor"], "");
  const { config: authorsPageConfig = {}, layout = "" } = get(props, ["collection", "associated-metadata"], {});
  let updatedConfig = {
    theme,
    ...authorsPageConfig
  };

  const data = get(props, ["collection", "props"], {});
  const updateStyle = layout === "ArrowPageIntroductionCard" ? "unset" : "";
  return (
    <div className="component-wrapper" styleName="intro-card" style={{ overflow: updateStyle }}>
      <Component data={data} config={updatedConfig} />
    </div>
  );
};
